import React from "react";
import {makeStyles} from "@mui/styles";

const StatusCircle = ({color}) => {
    const classes = useStyles();

    return (
        <div className={classes.circle} style={{backgroundColor: color}}></div>
    );
};

const useStyles = makeStyles(() => ({
    circle: {
        borderRadius: "50%",
        width: 12,
        height: 12,
        content: "''",
        marginLeft: 5
    }
}));

export default StatusCircle;